module.exports = __webpack_public_path__ + "static/transactionalemail-bodycopy-do-114b0e9cd98fd3732270c4f8b41e9574.png";